import httpClient from '../../../../shared/services/http/http-client';
import { ISetupInstructionsRecipient } from '../../shared-components/components/setup-instructions-dialog';
import {
  BusinessCentralLinkPurpose,
  IBusinessCentralConsentStep,
  IBusinessCentralLink,
  IBusinessCentralSignInStep,
  IBusinessCentralStatus,
} from './business-central.model';

const BASE = 'third-party-connection/businesscentral';

export default class BusinessCentralService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getStatus(): Promise<IBusinessCentralStatus> {
    return this.http.get(`${BASE}/status`).then(response => response.data)
  }

  /**
   * A link to Microsoft. 'consent' grants access and links the tenant (for a Microsoft
   * administrator); 'sign-in' only links a tenant whose administrator already granted access.
   * channel 'copy' also returns the setup instructions built around the link.
   */
  async createLink(purpose: BusinessCentralLinkPurpose, channel: 'button' | 'copy' = 'button'): Promise<IBusinessCentralLink> {
    return this.http.post(`${BASE}/connect-link`, { purpose, channel }).then(response => response.data)
  }

  async sendInstructions(recipient: ISetupInstructionsRecipient): Promise<IBusinessCentralStatus> {
    return this.http.post(`${BASE}/send-instructions`, recipient).then(response => response.data)
  }

  async testConnection(): Promise<IBusinessCentralStatus> {
    return this.http.post(`${BASE}/test`).then(response => response.data)
  }

  async updateEnvironment(environmentName: string): Promise<IBusinessCentralStatus> {
    return this.http.put(`${BASE}/environment`, { environmentName }).then(response => response.data)
  }

  async disconnect(): Promise<{ message: string }> {
    return this.http.delete(`${BASE}/connection`).then(response => response.data)
  }

  // ── Public: the page Microsoft sends the administrator back to ────────────────

  async consentReturned(details: { state: string, tenant?: string | null, error?: string | null, errorDescription?: string | null }): Promise<IBusinessCentralConsentStep> {
    return this.http.post('public-business-central/consent', details).then(response => response.data)
  }

  async signInReturned(details: { state: string, code?: string | null, error?: string | null, errorDescription?: string | null }): Promise<IBusinessCentralSignInStep> {
    return this.http.post('public-business-central/sign-in', details).then(response => response.data)
  }
}
